// GEIGHT-7 "Move to Gotrade Global" page, /check-my-options/ (amendment A8). Its emailed login link carries a
// one-time token in the URL fragment (#t=...), so the route ships with NO third-party tag: no GTM
// (and so no GA4/FB/TikTok/Clarity/Twitter), no gatsby-plugin-google-gtag, no OneSignal, no Adjust
// and no Partytown. An inline script, the first script in <head>, stashes the token in
// window.__gmvT and strips it from the address bar before anything else runs.
// Shared by gatsby-ssr.js, gatsby-browser.js and src/html.js, so plain CommonJS.

const GTG_MOVE_PATH = '/check-my-options/';

const GTG_MOVE_STASH_KEY = 'gtg-move-token-stash';

const SITE_HOSTS = new Set(['www.heygotrade.com', 'heygotrade.com']);

// S3 also serves the page at .../index.html (CloudFront passes paths with a dot through).
function isGtgMovePath(pathname) {
  if (!pathname) return false;
  const path = pathname.replace(/\/index\.html$/, '/');
  const withSlash = path.endsWith('/') ? path : `${path}/`;
  return withSlash === GTG_MOVE_PATH;
}

// Drops every `t=` piece of the fragment and keeps the other pieces byte for byte. The token
// (gotradeindo: `gmv_` + URL-safe base64, so [A-Za-z0-9_-]) is stashed only when it has that
// shape, so a mangled link never reaches the page as a token. Runs again on hashchange, for a
// second link opened in a tab already on the page; each link replaces the previous stash, so a
// mangled second link leaves no older token behind.
const GTG_MOVE_STASH_SCRIPT = `(function(){var w=window;function s(){try{var l=w.location,h=l.hash;if(!h||h.length<2)return;var p=h.slice(1).split('&'),r=[],t=null,i;for(i=0;i<p.length;i++){if(p[i].slice(0,2)==='t='){if(t===null)t=p[i].slice(2);}else r.push(p[i]);}if(t===null)return;w.__gmvT=/^[A-Za-z0-9_-]{1,512}$/.test(t)?t:void 0;w.history.replaceState(w.history.state,'',l.pathname+l.search+(r.length?'#'+r.join('&'):''));}catch(e){}}s();w.addEventListener('hashchange',s);})();`;

// Head parts gatsby-ssr.js and plugins add to every page, matched by key; anything else that
// loads from another origin is caught by isElsewhere below.
const THIRD_PARTY_KEYS = new Set([
  'gatsby-plugin-google-gtag',
  'gatsby-plugin-google-gtag-config',
  'preconnect-google-gtag',
  'dns-prefetch-google-gtag',
  'partytown',
  'partytown-datalayer',
  'gtm-web-vitals-polyfill',
  'gtm-deferred-loader',
  'gtm-noscript'
]);

// An absolute URL on any host but the site's own.
function isElsewhere(url) {
  if (typeof url !== 'string' || !/^(https?:)?\/\//i.test(url)) return false;
  try {
    return !SITE_HOSTS.has(new URL(url, 'https://www.heygotrade.com').hostname);
  } catch (e) {
    return true;
  }
}

function isThirdPartyElement(el) {
  if (!el || typeof el !== 'object') return false;
  if (THIRD_PARTY_KEYS.has(el.key)) return true;
  if (el.type === 'noscript') return true; // only GTM's iframe uses one
  const props = el.props || {};
  if (isElsewhere(props.src) || isElsewhere(props.href)) return true;
  return el.type === 'script' && (props.type === 'text/partytown' || 'data-partytown' in props);
}

// onPreRenderHTML on this route: drop every third-party part, then put the stash first.
function gtgMoveHead(head) {
  if (!Array.isArray(head)) return head;
  const kept = head.filter((el) => !isThirdPartyElement(el));
  const stash = kept.find((el) => el && el.key === GTG_MOVE_STASH_KEY);
  if (!stash) return kept;
  return [stash, ...kept.filter((el) => el !== stash)];
}

function withoutThirdParty(components) {
  return Array.isArray(components)
    ? components.filter((el) => !isThirdPartyElement(el))
    : components;
}

module.exports = {
  GTG_MOVE_PATH,
  GTG_MOVE_STASH_KEY,
  GTG_MOVE_STASH_SCRIPT,
  isGtgMovePath,
  isThirdPartyElement,
  gtgMoveHead,
  withoutThirdParty
};
